import React, { useState, useContext, useEffect } from "react";
import toastr from "toastr";
import { withRouter } from "react-router-dom";
import Button from "@material-ui/core/Button";
import CssBaseline from "@material-ui/core/CssBaseline";
import TextField from "@material-ui/core/TextField";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import Link from "@material-ui/core/Link";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import FormControl from "@material-ui/core/FormControl";
import InputAdornment from "@material-ui/core/InputAdornment";
import IconButton from "@material-ui/core/IconButton";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import CircularProgress from "@material-ui/core/CircularProgress";
import { makePOSTRequest } from "../../Api/api";
import { appContext } from "../../App";
import MultiFactorAuth from "../../components/MultiFactorAuth/MultiFactorAuth";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormLabel from "@mui/material/FormLabel";

const useStyles = makeStyles((theme) => ({
  paper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}));

const AdminUserLogin = (props) => {
  const classes = useStyles();
  const initialState = {
    emailId: "",
    plainTextPassword: "",
  };
  const [showPassword, setShowPassword] = useState(true);
  const [loginValues, setLoginValues] = useState(initialState);
  const [password, setPassword] = useState(initialState);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { authUser, setAuthUser } = useContext(appContext);
  const [showMultiFactorAuthScreen, setShowMultiFactorAuthScreen] =
    useState(false);
  const superuserDetailsInitialState = {
    mobileNumber: "",
    userUUID: "",
  };
  const [superuserDetails, setSuperuserDetails] = React.useState(
    superuserDetailsInitialState
  );
  const [userDetails, setUserDetails] = React.useState(null);
  const [accessToken, setAccessToken] = React.useState(null);
  const [otpPreference, setOTPPreference] = React.useState("Mobile");

  useEffect(() => {
    toastr.options = {
      closeButton: false,
      debug: false,
      newestOnTop: false,
      progressBar: false,
      positionClass: "toast-top-right",
      preventDuplicates: false,
      onclick: null,
      showDuration: "300",
      hideDuration: "1000",
      timeOut: "5000",
      extendedTimeOut: "1000",
      showEasing: "swing",
      hideEasing: "linear",
      showMethod: "fadeIn",
      hideMethod: "fadeOut",
    };
  }, []);

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const handleLoginDetails = (event) => {
    event.persist();
    setLoginValues((previousValues) => ({
      ...previousValues,
      [event.target.name]: event.target.value,
    }));
  };

  const handleEnterClick = (event) => {
    var code = event.keyCode || event.which;
    if (code === 13) {
      submitDetails(event);
    }
  };

  const handlePasswordChange = (event) => {
    setPassword((prev) => ({
      plainTextPassword: event.target.value,
    }));
  };

  const submitDetails = (event) => {
    if (loginValues.emailId && password.plainTextPassword) {
      setIsSubmitting(true);
      const requestBody = {
        mobileNumber: loginValues.emailId,
        password: password.plainTextPassword,
      };
      let url = "/users/admin_user/login/";
      makePOSTRequest(url, requestBody)
        .then((response) => {
          if (response && response.status === 200) {
            setShowMultiFactorAuthScreen(true);
            setSuperuserDetails({
              mobileNumber: loginValues.emailId,
            });
            localStorage.setItem("session", response.data.session);
            toastr.success("An OTP has been sent to your mobile number.");
          }
        })
        .catch((error) =>
          toastr.error("Invalid Credentials or the user does not exist ")
        )
        .finally(() => {
          setIsSubmitting(false);
        });
    } else {
      toastr.error("Please enter your moble number and password !");
    }
  };

  function returnLoginScreen() {
    return (
      <Container
        style={{ backgroundColor: "#FFFFF" }}
        className="mainLogin"
        maxWidth="xs"
      >
        <CssBaseline />
        <div className={classes.paper}>
          <Typography component="h1" variant="h5">
            Admin User Login
          </Typography>
          <form className={classes.form} noValidate>
            <TextField
              onChange={handleLoginDetails}
              onKeyPress={(e) => handleEnterClick(e)}
              variant="outlined"
              margin="normal"
              required
              fullWidth
              id="emailId"
              label="Mobile Number"
              name="emailId"
              autoComplete="emailId"
              autoFocus
            />
            <FormControl
              className="full-width border-radius"
              style={{ width: "100%" }}
            >
              <TextField
                onChange={handlePasswordChange}
                onKeyPress={(e) => handleEnterClick(e)}
                variant="outlined"
                margin="normal"
                required
                fullWidth
                name="password"
                label="Password"
                type={showPassword ? "password" : "text"}
                id="password"
                autoComplete="current-password"
              />
              <InputAdornment position="end" className="showpassword">
                <IconButton
                  aria-label="toggle password visibility"
                  style={{
                    top: "18px",
                    position: "absolute",
                    right: "18px",
                  }}
                  onClick={handleClickShowPassword}
                  edge="end"
                >
                  {showPassword ? <Visibility /> : <VisibilityOff />}
                </IconButton>
              </InputAdornment>
            </FormControl>
            <FormControl>
              <FormLabel id="demo-row-radio-buttons-group-label">
                Send OTP to
              </FormLabel>
              <RadioGroup
                row
                aria-labelledby="demo-row-radio-buttons-group-label"
                name="row-radio-buttons-group"
                value={otpPreference}
                onChange={(event) => {
                  event.preventDefault();
                  setOTPPreference(event.target.value);
                }}
              >
                <FormControlLabel
                  value="Mobile"
                  control={<Radio />}
                  label="Mobile"
                />
                {/* <FormControlLabel
                  value="Email"
                  control={<Radio />}
                  label="Email"
                /> */}
              </RadioGroup>
            </FormControl>

            <Button
              type="button"
              fullWidth
              variant="contained"
              color="primary"
              className={classes.submit}
              onClick={submitDetails}
              disabled={
                isSubmitting ||
                !loginValues.emailId ||
                !password.plainTextPassword
              }
            >
              {isSubmitting ? (
                <CircularProgress
                  size={22}
                  style={{ color: "primary", marginRight: 10 }}
                />
              ) : (
                "Sign In"
              )}
            </Button>
            <Grid container>
              <Grid item xs></Grid>
            </Grid>
          </form>
        </div>
      </Container>
    );
  }

  return (
    <Grid style={{ backgroundColor: "#1F2437", width: "100%" }}>
      {!showMultiFactorAuthScreen ? (
        returnLoginScreen()
      ) : (
        <MultiFactorAuth
          superuserDetails={superuserDetails}
          userDetails={userDetails}
          accessToken={accessToken}
          userType="admin_user"
          otpPreference={otpPreference}
        />
      )}
    </Grid>
  );
};

export default withRouter(AdminUserLogin);
